module.exports = __webpack_public_path__ + "static/media/selena-gomez-win.b44e9aea.jpg";